import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d2c2c610")

_pushScopeId("data-v-d2c2c610")
const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "h-38 mt-0" }
const _hoisted_4 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")
  const _component_DefaultButton = _resolveComponent("DefaultButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_qrcode_vue, {
          class: "mx-auto",
          value: $setup.qrCodeLink,
          size: $props.size,
          level: "H"
        }, null, 8, ["value", "size"])
      ]),
      _createVNode("a", {
        class: "mx-auto mt-0 pt-2 h-12 w-full justify-center text-center text-xl font-bold text-gray-700 dark:text-gray-400",
        href: $setup.qrCodeLink
      }, _toDisplayString(_ctx.$t("share.CardShare.telegramLinkPlaceholder")), 9, ["href"])
    ]),
    ($setup.activationExpired)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_DefaultButton, {
            "button-text": _ctx.$t('modal.SubscribeDialog.extend_activation'),
            "button-color": "bg-bp-light",
            "button-hover": "hover:bg-bp-light",
            "button-width": "w-auto",
            "button-x-margin": "mx-auto",
            "button-type": "button",
            onClick: $setup.extendActivation
          }, null, 8, ["button-text", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
})